import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import qs from 'qs';

const Success = ({ toSignIn }) => {
    const location = useLocation();
    const params = qs.parse(location.search, { ignoreQueryPrefix: true });

    const hasOAuthParams = params.response_type === 'code' && params.client_id && params.redirect_uri;

    return (
        <section>
            <h2 className="AuthWrapper__content-headline">Success! You have registered.</h2>
            <div className="AuthWrapper__content-message">
                <p>You can sign in on the next screen.</p>
            </div>
            <div className="AuthWrapper__content-action">
                {hasOAuthParams ? (
                    <Link
                        to={{
                            pathname: '/account/authorize',
                            search: window.location.search,
                        }}
                    >
                        <Button color="primary" block> Continue </Button>
                    </Link>
                ) : (
                    <Link to={toSignIn}>
                        <Button color="primary" block> Continue </Button>
                    </Link>
                )}
            </div>
        </section>
    );
};

Success.propTypes = {
    toSignIn: PropTypes.string.isRequired,
};

export default Success;
